module.exports = __webpack_public_path__ + "img/advance8.412cd743.png";